import { useQuery } from "@tanstack/react-query";
import { useState } from "react";
import { CACHE_KEYS } from "@api/constants/cacheKeys";
import URLS from "@api/constants/urls";
import { handleGlobalGetRequestQuery } from "@api/functions/getRequests";
import { IGetServiceProps } from "@api/types/globalService.types";
import useGlobalDebounceHandler from "./useGlobalDebounceHandler";

export const useGetAllCriticalIllnessesService = ({
  enableQuery = true,
  page = "1",
  per_page = "15",
}: IGetServiceProps) => {
  const [searchQuery, setSearchQuery] = useState<string>("");
  const { debouncedQuery } = useGlobalDebounceHandler(searchQuery);

  const allCriticalIllnessesService = useQuery({
    queryKey: [...CACHE_KEYS.CRITICALILLNESSES, page, debouncedQuery, per_page],
    queryFn: () =>
      handleGlobalGetRequestQuery({
        url: URLS.CRITICALILLNESSES,
        searchParams: {
          "filter[name]": debouncedQuery,
          page,
          per_page,
        },
      }),
    enabled: enableQuery,
  });
  return {
    services: { allCriticalIllnessesService },
    states: { searchQuery, setSearchQuery },
  };
};
